import { RcFile } from 'antd/lib/upload';
import html2canvas from 'html2canvas';
import moment from 'moment';
import Papa from 'papaparse';

export const copyToClipboard = async (text: string) => {
  await navigator.clipboard.writeText(text);
};

export const camelToTitleCase = (str: string) =>
  str.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase());

export const getBase64 = (file: RcFile): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const dateFormat = (str: string) => moment(str).format('YYYY-MM-DD');
export const dateLocaleFormat = (date: Date) => moment(date).format('YYYY-MM-DD hh:mm:ss');
export const timeLocaleFormat = (date: Date) => moment(date).format('HH:mm:ss');

export const camelize = (str: string) =>
  str
    .toLowerCase()
    .replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase())
    .replace(/[&/\\#,+()$~%.'":*?<>{}!@^_]/g, '');

export const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
export const capitalizeFirstLetterLow = (str: string) =>
  str.charAt(0).toUpperCase() + str.toLowerCase().slice(1);
export const getDivImage = async (divId: string, quality: number = 0.5) => {
  const element = document.getElementById(divId);
  if (element) {
    const canvas = await html2canvas(element);

    return canvas.toDataURL('image/png', quality);
  }
  return '';
};
export const filterEmptyRows = (data: any[]) =>
  data.filter((row) => Object.values(row).some((v) => v));

export const csvtoJSON = (file: File) =>
  new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      dynamicTyping: true,
      skipEmptyLines: true,

      complete: (results) => {
        resolve(filterEmptyRows(results.data));
      },
      error: (error) => {
        reject(error);
      },
    });
  });

export const downloadJsonToCSV = (data: any, fileName = 'data') => {
  const csv = Papa.unparse(data);
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', `${fileName}.csv`);
  link.click();
};

export const isInvalidEmail = (value: string) => {
  // eslint-disable-next-line no-useless-escape
  const emailRegex = /^([a-z0-9_\.-]+)@([\da-z\.-]+)\.([a-z\.]{2,6})$/;
  if (emailRegex.test(String(value))) {
    return false;
  }
  return true;
};

/*   convert product inventory item to shipment item */

export const isDevelopment = () =>
  window.location.hostname === 'happy-desert-0d2622110-develop.centralus.1.azurestaticapps.net' ||
  window.location.hostname === 'localhost';
